import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';
import { ITab } from 'src/app/model/tab';
import { isScatterSeries } from 'src/app/model/values-config';

@Injectable({ providedIn: 'root' })
export class GraphAgentValidationAdapterService {
  public validateTabs(tabs: ITab[]): string[] {
    const validationErrors: string[] = [];

    const emptyLabels = tabs.filter(tab => tab.graphConfig.label.trim() === '');
    if (emptyLabels.length > 0) {
      validationErrors.push('Graph label cannot be empty.');
    }

    const labelSet = new Set(tabs.map(tab => tab.graphConfig.label.trim().toLowerCase()));
    if (labelSet.size !== tabs.length) {
      validationErrors.push('Cannot save two graphs with the same label.');
    }

    for (const tab of tabs) {
      const forecastError = this.validateForecastSettings(tab);
      if (forecastError) {
        validationErrors.push(forecastError);
      }

      const axesError = this.validateAxesSettings(tab);
      if (axesError) {
        validationErrors.push(axesError);
      }
    }

    return [...new Set(validationErrors)];
  }

  private validateForecastSettings(tab: ITab): string | null {
    for (const series of tab.graphConfig.internalSeriesList) {
      if (!isScatterSeries(series)) {
        continue;
      }

      const forecasting = series.valueConfig.forecasting;
      if (forecasting.enabled && forecasting.periodLength <= 0) {
        return 'Forecast period length must be greater than zero.';
      }
    }

    return null;
  }

  private validateAxesSettings(tab: ITab): string | null {
    for (const series of tab.graphConfig.internalSeriesList) {
      if (!isScatterSeries(series)) {
        continue;
      }

      if (tab.graphConfig.timeReference === 'RELATIVE') {
        const xAxisLimits = series.valueConfig.relativeRangeToDisplay;
        if (xAxisLimits && xAxisLimits.from !== undefined && xAxisLimits.to !== undefined && xAxisLimits.from >= xAxisLimits.to) {
          return 'X-axis range: the start value must be smaller than the end value for all series.';
        }
      } else {
        const xAxisLimits = series.valueConfig.rangeToDisplay;
        if (
          xAxisLimits.from && xAxisLimits.to
          && DateTime.fromISO(xAxisLimits.from) > DateTime.fromISO(xAxisLimits.to)
        ) {
          return 'X-axis range: the start value must be smaller than the end value for all series.';
        }
      }
    }

    return null;
  }
}
